export default "__VITE_ASSET__Bai_8XJM__"